'use client';

import type { FC } from 'react';
import { Flex, Spinner } from '@eqi-investimentos/react';
import {
  ContentMode,
  ContentModeEnum,
  type Content,
} from '@/modules/Content/interface/Content';
import { PDFSlider } from '@/components/modules/PDFSlider';
import { IfRender } from '@/utils/jsx';
import { useGetPDFContent } from '../../http/client/useGetPDFContent';

export const ContentSlideMode: FC<ContentSlideModeProps> = ({
  content,
  contentMode,
}) => {
  const { data: { pages } = { pages: [] }, isFetching } = useGetPDFContent(
    content.presentation
  );

  return (
    <IfRender condition={contentMode === ContentModeEnum.SLIDE}>
      <Flex
        alignItems="center"
        justifyContent="center"
        w="full"
        minH="20rem"
        bgColor="background.alwaysDark"
      >
        {isFetching && <Spinner size="xl" />}
        {pages.length > 0 && <PDFSlider pages={pages} />}
      </Flex>
    </IfRender>
  );
};

type ContentSlideModeProps = {
  content: Content;
  contentMode: ContentMode;
};
